export default {
	props: {
		account: {
			type: Object,
			default: () => null
		},
		app: {
			type: Object,
			default: () => null
		},
		connectionIsOnline: {
			type: Boolean,
			default: true
		},
		customer: {
			type: Object,
			default: () => null
		},
		error: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		isCompany: {
			type: Boolean,
			default: false
		},
		isEmpty: {
			type: Boolean,
			default: true
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isNewMethod: {
			type: Boolean,
			default: false
		},
		isNewCart: {
			type: Boolean,
			default: true
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		paymentContainer: {
			type: Object,
			default: () => null
		},
		retargetingUrl: {
			type: String,
			default: ''
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		providerAccount: {
			type: Object,
			default: () => {}
		},
		shouldGetOffer: {
			type: Boolean,
			default: false
		},
		modal: {
			type: String,
			default: ''
		},
		terms: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		},
		utils: {
			type: Object,
			default: () => null
		}
	}
};
